import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import fbImg from '../img/fb.png';
import instaImg from '../img/insta.png';
import tiktokImg from '../img/tik-tok.png';
import { getAuthToken } from '../utils/auth';

const Footer = () => {
    const navigate = useNavigate();
    const isAuthenticated = !!getAuthToken();
    const location = useLocation();
    const role = location?.state?.role || localStorage.getItem('role');

    const handleMyPostsClick = (event) => {
        event.preventDefault();
        navigate('/dashboard');
    };

    const handlePostsClick = (event) => {
        event.preventDefault();
        navigate('/admin');
    };

    return (<>
        <footer className="website-footer">
            <div className="container">
                <div className="footer-main-flex">
                    <div className="follow-us">
                        <h4 className="footer-title">Follows US </h4>
                        <ul className="ft-social">
                            <li><NavLink to="/"><img src={fbImg} alt="facebook" /></NavLink></li>
                            <li><NavLink to="/"> <img src={instaImg} alt="instagram" /></NavLink></li>
                            <li><NavLink to="/"><img src={tiktokImg} alt="tiktok" /></NavLink></li>
                        </ul>
                    </div>

                    <div className="ft-contacts">
                        <h4 className="footer-title">Contacts</h4>
                        <ul>
                            <li>Elliott Ave, Parkville VIC 3052, Melbourne Canada</li>
                            <li>Phone: +123456789</li>
                            <li>Email: support@flyinghelp.org</li>
                        </ul>
                    </div>

                    <div className="ft-menu--link">
                        <h4 className="footer-title">Menu & Links</h4>
                        <ul>
                            {!isAuthenticated && (
                                <>
                                    <li><NavLink className="active" to="/">Home</NavLink></li>
                                    <li><NavLink to="/about">About</NavLink></li>
                                    {/* <li><NavLink to="/blogs">Blog</NavLink></li> */}
                                    <li><NavLink to="/contact">Contact Us</NavLink></li>
                                </>
                            )}
                            {isAuthenticated && (
                                <>
                                    {role === '' && (
                                        <>
                                            <li><NavLink className="active" to="/">Home</NavLink></li>
                                            <li><NavLink to="/about">About</NavLink></li>
                                            {/* <li><NavLink to="/blogs">Blog</NavLink></li> */}
                                            <li><NavLink to="/contact">Contact Us</NavLink></li>
                                        </>
                                    )}
                                    {role === 'user' && (
                                        <>
                                            <li><NavLink className="active" to="/">Home</NavLink></li>
                                            <li><NavLink to="/about">About</NavLink></li>
                                            {/* <li><NavLink to="/blogs">Blog</NavLink></li> */}
                                            <li><NavLink to="/contact">Contact Us</NavLink></li>
                                            <li><NavLink to="dashboard" onClick={handleMyPostsClick}>Dashboard</NavLink></li>
                                            <li><NavLink to="/profile">My Profile</NavLink></li>
                                        </>
                                    )}
                                    {role === 'admin' && (
                                        <>
                                            <li><NavLink className="active" to="/">Home</NavLink></li>
                                            <li><NavLink to="/admin" onClick={handlePostsClick}>Admin Panel</NavLink></li>
                                            {/* <li><NavLink to="/blogs">Blog</NavLink></li> */}
                                            <li><NavLink to="/users">Users</NavLink></li>
                                            <li><NavLink to="/profile">My Profile</NavLink></li>
                                        </>
                                    )}
                                </>
                            )}

                        </ul>
                    </div>

                    <div className="ft-donate">
                        <h4 className="footer-title">Donate</h4>
                        <ul>
                            <li>Help Us Change the Lives of in World</li>
                        </ul>
                        <a href="/posts" className="donate-ft">Donate</a>
                    </div>

                </div>
            </div>
        </footer>
    </>
    )
}
export default Footer;
